export interface IssueRecordModel {
    comments: string;
    createdBy: string;
    createdDate: Date;
    history?: IssueRecordModel[];
}

export interface IssueRestrictedFields {
    certificationRestricted: boolean;
    endorsementRestricted: boolean;
    paymentRestricted: boolean;
}

export interface IssueHistory extends IssueRestrictedFields {
    id: string;
    parentIssueRecordId: string | null;
    body: string;
    programPartnerId: string;
    createdBy: string;
    modifiedBy: string | null;
    archivedBy: string | null;
    dateCreated: Date;
    dateModified: Date | null;
    dateArchived: Date | null;
    createdByName: string;
    modifiedByName: string;
    archivedByName: string;
    history: IssueHistory[] | null;
}

export interface IssueRecordFilter {
    programPartnerId: string;
}

export interface IssueTrackingPayload extends IssueRestrictedFields {
    parentIssueRecordId: string | null;
    body: string;
    programPartnerId: string;
    dateReported: Date;
}

export interface IssueThreadParentMatch {
    root: IssueHistory;
    parent: IssueHistory;
    historyList: IssueHistory[];
}

export const EMPTY_ISSUE_RESTRICTIONS: IssueRestrictedFields = {
    certificationRestricted: false,
    endorsementRestricted: false,
    paymentRestricted: false
};

export function getActiveParentIssueRestrictions(
    issues: IssueHistory[] | null | undefined
): IssueRestrictedFields {
    const restrictions: IssueRestrictedFields = { ...EMPTY_ISSUE_RESTRICTIONS };

    for (const issue of issues ?? []) {
        const parentIssueRecordId = issue.parentIssueRecordId?.trim();
        const isParentLevelIssue = !parentIssueRecordId;
        const isActiveIssue = issue.dateArchived == null;

        if (!isParentLevelIssue || !isActiveIssue) {
            continue;
        }

        restrictions.certificationRestricted =
            restrictions.certificationRestricted || issue.certificationRestricted === true;
        restrictions.endorsementRestricted =
            restrictions.endorsementRestricted || issue.endorsementRestricted === true;
        restrictions.paymentRestricted = restrictions.paymentRestricted || issue.paymentRestricted === true;
    }

    return restrictions;
}